import React from "react";
import { connect, DispatchProp } from "react-redux";
import { StoreState } from "../models/states/StoreState";
import { ThemedSurveyEngine } from "../components/SurveyEngine";
import { SurveyMode } from "../models/enums/SurveyMode";
import { ErrorLog } from "../components/shared/ErrorLog";

interface StateProps {
    ready: boolean;
    debug: boolean;
    mode: SurveyMode;
    progress: number;
}

interface State {
    error?: Error;
}

class AppImpl extends React.PureComponent<StateProps & DispatchProp, State> {
    constructor(props: StateProps & DispatchProp) {
        super(props);
        this.state = {};
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        // Display fallback UI
        this.setState({ error });
        console.log(error);
    }

    render() {
        const { error } = this.state;
        if (error) return <ErrorLog errors={[{ error }]} />;
        const { progress } = this.props;
        return (
            <>
                {progress && (
                    <div className="connection-progress" key={0}>
                        <div
                            className="connection-progress__fill"
                            style={{ width: `${progress * 100}%` }}
                        />
                    </div>
                )}
                <ThemedSurveyEngine />
            </>
        );
    }
}

const mapStateToProps = (state: StoreState): StateProps => ({
    ready:
        state.interview &&
        state.interview.navigation.currentPage &&
        state.interview.navigation.currentPage.isReady,
    debug: state.application.debug,
    mode: state.application.mode,
    progress: state.connection.progress,
});

export const App = connect(mapStateToProps)(AppImpl);
